<template>
  <a href={{@value}} target='_blank' rel='noopener noreferrer'>{{@value}}</a>
</template>
